import React from 'react';
import PropTypes from 'prop-types';

import { StyledSkeleton } from './styled';

export default function BaseSkeleton({
  borderRadius,
  count,
  circle,
  height,
  inline,
  width,
  ...props
}) {
  return (
    <StyledSkeleton
      borderRadius={borderRadius}
      count={count}
      circle={circle}
      height={height}
      inline={inline}
      width={width}
      {...props}
    />
  );
}

BaseSkeleton.propTypes = {
  borderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  count: PropTypes.number,
  circle: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  inline: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

BaseSkeleton.defaultProps = {
  borderRadius: 8,
  count: 1,
  circle: false,
  height: undefined,
  inline: false,
  width: '100%',
};
